const PRICE_LIST_SEIMEI_COURSE = {
  ID: "seimei-course",
  PRICE_M: [
    {
      AGE: 15,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 16,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 17,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 18,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 19,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 20,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 21,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 22,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 23,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 24,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 25,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 26,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 27,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 28,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 29,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 30,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 31,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 32,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 33,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 34,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 35,
      14: 5730,
      13: 5157,
      12: 4584,
      11: 4011,
      10: 3438,
      9: 2865,
      8: 2292,
      7: 1719,
      6: 1146,
      5: 802,
      4: 573,
      3: 343,
      2: 229,
      1: 114,
    },
    {
      AGE: 36,
      14: 6270,
      13: 5643,
      12: 5016,
      11: 4389,
      10: 3762,
      9: 3135,
      8: 2508,
      7: 1881,
      6: 1254,
      5: 877,
      4: 627,
      3: 376,
      2: 250,
      1: 125,
    },
    {
      AGE: 37,
      14: 6270,
      13: 5643,
      12: 5016,
      11: 4389,
      10: 3762,
      9: 3135,
      8: 2508,
      7: 1881,
      6: 1254,
      5: 877,
      4: 627,
      3: 376,
      2: 250,
      1: 125,
    },
    {
      AGE: 38,
      14: 6270,
      13: 5643,
      12: 5016,
      11: 4389,
      10: 3762,
      9: 3135,
      8: 2508,
      7: 1881,
      6: 1254,
      5: 877,
      4: 627,
      3: 376,
      2: 250,
      1: 125,
    },
    {
      AGE: 39,
      14: 6270,
      13: 5643,
      12: 5016,
      11: 4389,
      10: 3762,
      9: 3135,
      8: 2508,
      7: 1881,
      6: 1254,
      5: 877,
      4: 627,
      3: 376,
      2: 250,
      1: 125,
    },
    {
      AGE: 40,
      14: 6270,
      13: 5643,
      12: 5016,
      11: 4389,
      10: 3762,
      9: 3135,
      8: 2508,
      7: 1881,
      6: 1254,
      5: 877,
      4: 627,
      3: 376,
      2: 250,
      1: 125,
    },
    {
      AGE: 41,
      14: 7170,
      13: 6453,
      12: 5736,
      11: 5019,
      10: 4302,
      9: 3585,
      8: 2868,
      7: 2151,
      6: 1434,
      5: 1003,
      4: 717,
      3: 430,
      2: 286,
      1: 143,
    },
    {
      AGE: 42,
      14: 7170,
      13: 6453,
      12: 5736,
      11: 5019,
      10: 4302,
      9: 3585,
      8: 2868,
      7: 2151,
      6: 1434,
      5: 1003,
      4: 717,
      3: 430,
      2: 286,
      1: 143,
    },
    {
      AGE: 43,
      14: 7170,
      13: 6453,
      12: 5736,
      11: 5019,
      10: 4302,
      9: 3585,
      8: 2868,
      7: 2151,
      6: 1434,
      5: 1003,
      4: 717,
      3: 430,
      2: 286,
      1: 143,
    },
    {
      AGE: 44,
      14: 7170,
      13: 6453,
      12: 5736,
      11: 5019,
      10: 4302,
      9: 3585,
      8: 2868,
      7: 2151,
      6: 1434,
      5: 1003,
      4: 717,
      3: 430,
      2: 286,
      1: 143,
    },
    {
      AGE: 45,
      14: 7170,
      13: 6453,
      12: 5736,
      11: 5019,
      10: 4302,
      9: 3585,
      8: 2868,
      7: 2151,
      6: 1434,
      5: 1003,
      4: 717,
      3: 430,
      2: 286,
      1: 143,
    },
    {
      AGE: 46,
      14: 8670,
      13: 7803,
      12: 6936,
      11: 6069,
      10: 5202,
      9: 4335,
      8: 3468,
      7: 2601,
      6: 1734,
      5: 1213,
      4: 867,
      3: 520,
      2: 346,
      1: 173,
    },
    {
      AGE: 47,
      14: 8670,
      13: 7803,
      12: 6936,
      11: 6069,
      10: 5202,
      9: 4335,
      8: 3468,
      7: 2601,
      6: 1734,
      5: 1213,
      4: 867,
      3: 520,
      2: 346,
      1: 173,
    },
    {
      AGE: 48,
      14: 8670,
      13: 7803,
      12: 6936,
      11: 6069,
      10: 5202,
      9: 4335,
      8: 3468,
      7: 2601,
      6: 1734,
      5: 1213,
      4: 867,
      3: 520,
      2: 346,
      1: 173,
    },
    {
      AGE: 49,
      14: 8670,
      13: 7803,
      12: 6936,
      11: 6069,
      10: 5202,
      9: 4335,
      8: 3468,
      7: 2601,
      6: 1734,
      5: 1213,
      4: 867,
      3: 520,
      2: 346,
      1: 173,
    },
    {
      AGE: 50,
      14: 8670,
      13: 7803,
      12: 6936,
      11: 6069,
      10: 5202,
      9: 4335,
      8: 3468,
      7: 2601,
      6: 1734,
      5: 1213,
      4: 867,
      3: 520,
      2: 346,
      1: 173,
    },
    {
      AGE: 51,
      14: 10920,
      13: 9828,
      12: 8736,
      11: 7644,
      10: 6552,
      9: 5460,
      8: 4368,
      7: 3276,
      6: 2184,
      5: 1528,
      4: 1092,
      3: 655,
      2: 436,
      1: 218,
    },
    {
      AGE: 52,
      14: 10920,
      13: 9828,
      12: 8736,
      11: 7644,
      10: 6552,
      9: 5460,
      8: 4368,
      7: 3276,
      6: 2184,
      5: 1528,
      4: 1092,
      3: 655,
      2: 436,
      1: 218,
    },
    {
      AGE: 53,
      14: 10920,
      13: 9828,
      12: 8736,
      11: 7644,
      10: 6552,
      9: 5460,
      8: 4368,
      7: 3276,
      6: 2184,
      5: 1528,
      4: 1092,
      3: 655,
      2: 436,
      1: 218,
    },
    {
      AGE: 54,
      14: 10920,
      13: 9828,
      12: 8736,
      11: 7644,
      10: 6552,
      9: 5460,
      8: 4368,
      7: 3276,
      6: 2184,
      5: 1528,
      4: 1092,
      3: 655,
      2: 436,
      1: 218,
    },
    {
      AGE: 55,
      14: 10920,
      13: 9828,
      12: 8736,
      11: 7644,
      10: 6552,
      9: 5460,
      8: 4368,
      7: 3276,
      6: 2184,
      5: 1528,
      4: 1092,
      3: 655,
      2: 436,
      1: 218,
    },
    {
      AGE: 56,
      14: 14100,
      13: 12690,
      12: 11280,
      11: 9870,
      10: 8460,
      9: 7050,
      8: 5640,
      7: 4230,
      6: 2820,
      5: 1974,
      4: 1410,
      3: 846,
      2: 564,
      1: 282,
    },
    {
      AGE: 57,
      14: 14100,
      13: 12690,
      12: 11280,
      11: 9870,
      10: 8460,
      9: 7050,
      8: 5640,
      7: 4230,
      6: 2820,
      5: 1974,
      4: 1410,
      3: 846,
      2: 564,
      1: 282,
    },
    {
      AGE: 58,
      14: 14100,
      13: 12690,
      12: 11280,
      11: 9870,
      10: 8460,
      9: 7050,
      8: 5640,
      7: 4230,
      6: 2820,
      5: 1974,
      4: 1410,
      3: 846,
      2: 564,
      1: 282,
    },
    {
      AGE: 59,
      14: 14100,
      13: 12690,
      12: 11280,
      11: 9870,
      10: 8460,
      9: 7050,
      8: 5640,
      7: 4230,
      6: 2820,
      5: 1974,
      4: 1410,
      3: 846,
      2: 564,
      1: 282,
    },
    {
      AGE: 60,
      14: 14100,
      13: 12690,
      12: 11280,
      11: 9870,
      10: 8460,
      9: 7050,
      8: 5640,
      7: 4230,
      6: 2820,
      5: 1974,
      4: 1410,
      3: 846,
      2: 564,
      1: 282,
    },
    {
      AGE: 61,
      14: 19620,
      13: 17658,
      12: 15696,
      11: 13734,
      10: 11772,
      9: 9810,
      8: 7848,
      7: 5886,
      6: 3924,
      5: 2746,
      4: 1962,
      3: 1177,
      2: 784,
      1: 392,
    },
    {
      AGE: 62,
      14: 19620,
      13: 17658,
      12: 15696,
      11: 13734,
      10: 11772,
      9: 9810,
      8: 7848,
      7: 5886,
      6: 3924,
      5: 2746,
      4: 1962,
      3: 1177,
      2: 784,
      1: 392,
    },
    {
      AGE: 63,
      14: 19620,
      13: 17658,
      12: 15696,
      11: 13734,
      10: 11772,
      9: 9810,
      8: 7848,
      7: 5886,
      6: 3924,
      5: 2746,
      4: 1962,
      3: 1177,
      2: 784,
      1: 392,
    },
    {
      AGE: 64,
      14: 19620,
      13: 17658,
      12: 15696,
      11: 13734,
      10: 11772,
      9: 9810,
      8: 7848,
      7: 5886,
      6: 3924,
      5: 2746,
      4: 1962,
      3: 1177,
      2: 784,
      1: 392,
    },
    {
      AGE: 65,
      14: 19620,
      13: 17658,
      12: 15696,
      11: 13734,
      10: 11772,
      9: 9810,
      8: 7848,
      7: 5886,
      6: 3924,
      5: 2746,
      4: 1962,
      3: 1177,
      2: 784,
      1: 392,
    },
    {
      AGE: 66,
      14: 27270,
      13: 24543,
      12: 21816,
      11: 19089,
      10: 16362,
      9: 13635,
      8: 10908,
      7: 8181,
      6: 5454,
      5: 3817,
      4: 2727,
      3: 1636,
      2: 1090,
      1: 545,
    },
    {
      AGE: 67,
      14: 27270,
      13: 24543,
      12: 21816,
      11: 19089,
      10: 16362,
      9: 13635,
      8: 10908,
      7: 8181,
      6: 5454,
      5: 3817,
      4: 2727,
      3: 1636,
      2: 1090,
      1: 545,
    },
    {
      AGE: 68,
      14: 27270,
      13: 24543,
      12: 21816,
      11: 19089,
      10: 16362,
      9: 13635,
      8: 10908,
      7: 8181,
      6: 5454,
      5: 3817,
      4: 2727,
      3: 1636,
      2: 1090,
      1: 545,
    },
    {
      AGE: 69,
      14: 27270,
      13: 24543,
      12: 21816,
      11: 19089,
      10: 16362,
      9: 13635,
      8: 10908,
      7: 8181,
      6: 5454,
      5: 3817,
      4: 2727,
      3: 1636,
      2: 1090,
      1: 545,
    },
    {
      AGE: 70,
      14: 27270,
      13: 24543,
      12: 21816,
      11: 19089,
      10: 16362,
      9: 13635,
      8: 10908,
      7: 8181,
      6: 5454,
      5: 3817,
      4: 2727,
      3: 1636,
      2: 1090,
      1: 545,
    },
    {
      AGE: 71,
      14: 34530,
      13: 31077,
      12: 27624,
      11: 24171,
      10: 20718,
      9: 17265,
      8: 13812,
      7: 10359,
      6: 6906,
      5: 4834,
      4: 3453,
      3: 2071,
      2: 1381,
      1: 690,
    },
    {
      AGE: 72,
      14: 37830,
      13: 34047,
      12: 30264,
      11: 26481,
      10: 22698,
      9: 18915,
      8: 15132,
      7: 11349,
      6: 7566,
      5: 5296,
      4: 3783,
      3: 2269,
      2: 1513,
      1: 756,
    },
    {
      AGE: 73,
      14: 41610,
      13: 37449,
      12: 33288,
      11: 29127,
      10: 24966,
      9: 20805,
      8: 16644,
      7: 12483,
      6: 8322,
      5: 5825,
      4: 4161,
      3: 2496,
      2: 1664,
      1: 832,
    },
    {
      AGE: 74,
      14: 46020,
      13: 41418,
      12: 36816,
      11: 32214,
      10: 27612,
      9: 23010,
      8: 18408,
      7: 13806,
      6: 9204,
      5: 6442,
      4: 4602,
      3: 2761,
      2: 1840,
      1: 920,
    },
    {
      AGE: 75,
      14: 51240,
      13: 46116,
      12: 40992,
      11: 35868,
      10: 30744,
      9: 25620,
      8: 20496,
      7: 15372,
      6: 10248,
      5: 7173,
      4: 5124,
      3: 3074,
      2: 2049,
      1: 1024,
    },
  ],
  PRICE_F: [
    {
      AGE: 15,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 16,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 17,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 18,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 19,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 20,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 21,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 22,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 23,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 24,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 25,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 26,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 27,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 28,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 29,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 30,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 31,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 32,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 33,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 34,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 35,
      14: 5010,
      13: 4509,
      12: 4008,
      11: 3507,
      10: 3006,
      9: 2505,
      8: 2004,
      7: 1503,
      6: 1002,
      5: 701,
      4: 501,
      3: 300,
      2: 200,
      1: 100,
    },
    {
      AGE: 36,
      14: 5880,
      13: 5292,
      12: 4704,
      11: 4116,
      10: 3528,
      9: 2940,
      8: 2352,
      7: 1764,
      6: 1176,
      5: 823,
      4: 588,
      3: 352,
      2: 235,
      1: 117,
    },
    {
      AGE: 37,
      14: 5880,
      13: 5292,
      12: 4704,
      11: 4116,
      10: 3528,
      9: 2940,
      8: 2352,
      7: 1764,
      6: 1176,
      5: 823,
      4: 588,
      3: 352,
      2: 235,
      1: 117,
    },
    {
      AGE: 38,
      14: 5880,
      13: 5292,
      12: 4704,
      11: 4116,
      10: 3528,
      9: 2940,
      8: 2352,
      7: 1764,
      6: 1176,
      5: 823,
      4: 588,
      3: 352,
      2: 235,
      1: 117,
    },
    {
      AGE: 39,
      14: 5880,
      13: 5292,
      12: 4704,
      11: 4116,
      10: 3528,
      9: 2940,
      8: 2352,
      7: 1764,
      6: 1176,
      5: 823,
      4: 588,
      3: 352,
      2: 235,
      1: 117,
    },
    {
      AGE: 40,
      14: 5880,
      13: 5292,
      12: 4704,
      11: 4116,
      10: 3528,
      9: 2940,
      8: 2352,
      7: 1764,
      6: 1176,
      5: 823,
      4: 588,
      3: 352,
      2: 235,
      1: 117,
    },
    {
      AGE: 41,
      14: 6360,
      13: 5724,
      12: 5088,
      11: 4452,
      10: 3816,
      9: 3180,
      8: 2544,
      7: 1908,
      6: 1272,
      5: 890,
      4: 636,
      3: 381,
      2: 254,
      1: 127,
    },
    {
      AGE: 42,
      14: 6360,
      13: 5724,
      12: 5088,
      11: 4452,
      10: 3816,
      9: 3180,
      8: 2544,
      7: 1908,
      6: 1272,
      5: 890,
      4: 636,
      3: 381,
      2: 254,
      1: 127,
    },
    {
      AGE: 43,
      14: 6360,
      13: 5724,
      12: 5088,
      11: 4452,
      10: 3816,
      9: 3180,
      8: 2544,
      7: 1908,
      6: 1272,
      5: 890,
      4: 636,
      3: 381,
      2: 254,
      1: 127,
    },
    {
      AGE: 44,
      14: 6360,
      13: 5724,
      12: 5088,
      11: 4452,
      10: 3816,
      9: 3180,
      8: 2544,
      7: 1908,
      6: 1272,
      5: 890,
      4: 636,
      3: 381,
      2: 254,
      1: 127,
    },
    {
      AGE: 45,
      14: 6360,
      13: 5724,
      12: 5088,
      11: 4452,
      10: 3816,
      9: 3180,
      8: 2544,
      7: 1908,
      6: 1272,
      5: 890,
      4: 636,
      3: 381,
      2: 254,
      1: 127,
    },
    {
      AGE: 46,
      14: 7440,
      13: 6696,
      12: 5952,
      11: 5208,
      10: 4464,
      9: 3720,
      8: 2976,
      7: 2232,
      6: 1488,
      5: 1041,
      4: 744,
      3: 446,
      2: 297,
      1: 148,
    },
    {
      AGE: 47,
      14: 7440,
      13: 6696,
      12: 5952,
      11: 5208,
      10: 4464,
      9: 3720,
      8: 2976,
      7: 2232,
      6: 1488,
      5: 1041,
      4: 744,
      3: 446,
      2: 297,
      1: 148,
    },
    {
      AGE: 48,
      14: 7440,
      13: 6696,
      12: 5952,
      11: 5208,
      10: 4464,
      9: 3720,
      8: 2976,
      7: 2232,
      6: 1488,
      5: 1041,
      4: 744,
      3: 446,
      2: 297,
      1: 148,
    },
    {
      AGE: 49,
      14: 7440,
      13: 6696,
      12: 5952,
      11: 5208,
      10: 4464,
      9: 3720,
      8: 2976,
      7: 2232,
      6: 1488,
      5: 1041,
      4: 744,
      3: 446,
      2: 297,
      1: 148,
    },
    {
      AGE: 50,
      14: 7440,
      13: 6696,
      12: 5952,
      11: 5208,
      10: 4464,
      9: 3720,
      8: 2976,
      7: 2232,
      6: 1488,
      5: 1041,
      4: 744,
      3: 446,
      2: 297,
      1: 148,
    },
    {
      AGE: 51,
      14: 8760,
      13: 7884,
      12: 7008,
      11: 6132,
      10: 5256,
      9: 4380,
      8: 3504,
      7: 2628,
      6: 1752,
      5: 1226,
      4: 876,
      3: 525,
      2: 350,
      1: 175,
    },
    {
      AGE: 52,
      14: 8760,
      13: 7884,
      12: 7008,
      11: 6132,
      10: 5256,
      9: 4380,
      8: 3504,
      7: 2628,
      6: 1752,
      5: 1226,
      4: 876,
      3: 525,
      2: 350,
      1: 175,
    },
    {
      AGE: 53,
      14: 8760,
      13: 7884,
      12: 7008,
      11: 6132,
      10: 5256,
      9: 4380,
      8: 3504,
      7: 2628,
      6: 1752,
      5: 1226,
      4: 876,
      3: 525,
      2: 350,
      1: 175,
    },
    {
      AGE: 54,
      14: 8760,
      13: 7884,
      12: 7008,
      11: 6132,
      10: 5256,
      9: 4380,
      8: 3504,
      7: 2628,
      6: 1752,
      5: 1226,
      4: 876,
      3: 525,
      2: 350,
      1: 175,
    },
    {
      AGE: 55,
      14: 8760,
      13: 7884,
      12: 7008,
      11: 6132,
      10: 5256,
      9: 4380,
      8: 3504,
      7: 2628,
      6: 1752,
      5: 1226,
      4: 876,
      3: 525,
      2: 350,
      1: 175,
    },
    {
      AGE: 56,
      14: 10110,
      13: 9099,
      12: 8088,
      11: 7077,
      10: 6066,
      9: 5055,
      8: 4044,
      7: 3033,
      6: 2022,
      5: 1415,
      4: 1011,
      3: 606,
      2: 404,
      1: 202,
    },
    {
      AGE: 57,
      14: 10110,
      13: 9099,
      12: 8088,
      11: 7077,
      10: 6066,
      9: 5055,
      8: 4044,
      7: 3033,
      6: 2022,
      5: 1415,
      4: 1011,
      3: 606,
      2: 404,
      1: 202,
    },
    {
      AGE: 58,
      14: 10110,
      13: 9099,
      12: 8088,
      11: 7077,
      10: 6066,
      9: 5055,
      8: 4044,
      7: 3033,
      6: 2022,
      5: 1415,
      4: 1011,
      3: 606,
      2: 404,
      1: 202,
    },
    {
      AGE: 59,
      14: 10110,
      13: 9099,
      12: 8088,
      11: 7077,
      10: 6066,
      9: 5055,
      8: 4044,
      7: 3033,
      6: 2022,
      5: 1415,
      4: 1011,
      3: 606,
      2: 404,
      1: 202,
    },
    {
      AGE: 60,
      14: 10110,
      13: 9099,
      12: 8088,
      11: 7077,
      10: 6066,
      9: 5055,
      8: 4044,
      7: 3033,
      6: 2022,
      5: 1415,
      4: 1011,
      3: 606,
      2: 404,
      1: 202,
    },
    {
      AGE: 61,
      14: 12180,
      13: 10962,
      12: 9744,
      11: 8526,
      10: 7308,
      9: 6090,
      8: 4872,
      7: 3654,
      6: 2436,
      5: 1705,
      4: 1218,
      3: 730,
      2: 487,
      1: 243,
    },
    {
      AGE: 62,
      14: 12180,
      13: 10962,
      12: 9744,
      11: 8526,
      10: 7308,
      9: 6090,
      8: 4872,
      7: 3654,
      6: 2436,
      5: 1705,
      4: 1218,
      3: 730,
      2: 487,
      1: 243,
    },
    {
      AGE: 63,
      14: 12180,
      13: 10962,
      12: 9744,
      11: 8526,
      10: 7308,
      9: 6090,
      8: 4872,
      7: 3654,
      6: 2436,
      5: 1705,
      4: 1218,
      3: 730,
      2: 487,
      1: 243,
    },
    {
      AGE: 64,
      14: 12180,
      13: 10962,
      12: 9744,
      11: 8526,
      10: 7308,
      9: 6090,
      8: 4872,
      7: 3654,
      6: 2436,
      5: 1705,
      4: 1218,
      3: 730,
      2: 487,
      1: 243,
    },
    {
      AGE: 65,
      14: 12180,
      13: 10962,
      12: 9744,
      11: 8526,
      10: 7308,
      9: 6090,
      8: 4872,
      7: 3654,
      6: 2436,
      5: 1705,
      4: 1218,
      3: 730,
      2: 487,
      1: 243,
    },
    {
      AGE: 66,
      14: 15120,
      13: 13608,
      12: 12096,
      11: 10584,
      10: 9072,
      9: 7560,
      8: 6048,
      7: 4536,
      6: 3024,
      5: 2116,
      4: 1512,
      3: 907,
      2: 604,
      1: 302,
    },
    {
      AGE: 67,
      14: 15120,
      13: 13608,
      12: 12096,
      11: 10584,
      10: 9072,
      9: 7560,
      8: 6048,
      7: 4536,
      6: 3024,
      5: 2116,
      4: 1512,
      3: 907,
      2: 604,
      1: 302,
    },
    {
      AGE: 68,
      14: 15120,
      13: 13608,
      12: 12096,
      11: 10584,
      10: 9072,
      9: 7560,
      8: 6048,
      7: 4536,
      6: 3024,
      5: 2116,
      4: 1512,
      3: 907,
      2: 604,
      1: 302,
    },
    {
      AGE: 69,
      14: 15120,
      13: 13608,
      12: 12096,
      11: 10584,
      10: 9072,
      9: 7560,
      8: 6048,
      7: 4536,
      6: 3024,
      5: 2116,
      4: 1512,
      3: 907,
      2: 604,
      1: 302,
    },
    {
      AGE: 70,
      14: 15120,
      13: 13608,
      12: 12096,
      11: 10584,
      10: 9072,
      9: 7560,
      8: 6048,
      7: 4536,
      6: 3024,
      5: 2116,
      4: 1512,
      3: 907,
      2: 604,
      1: 302,
    },
    {
      AGE: 71,
      14: 18840,
      13: 16956,
      12: 15072,
      11: 13188,
      10: 11304,
      9: 9420,
      8: 7536,
      7: 5652,
      6: 3768,
      5: 2637,
      4: 1884,
      3: 1130,
      2: 753,
      1: 376,
    },
    {
      AGE: 72,
      14: 20550,
      13: 18495,
      12: 16440,
      11: 14385,
      10: 12330,
      9: 10275,
      8: 8220,
      7: 6165,
      6: 4110,
      5: 2877,
      4: 2055,
      3: 1233,
      2: 822,
      1: 411,
    },
    {
      AGE: 73,
      14: 22560,
      13: 20304,
      12: 18048,
      11: 15792,
      10: 13536,
      9: 11280,
      8: 9024,
      7: 6768,
      6: 4512,
      5: 3158,
      4: 2256,
      3: 1353,
      2: 902,
      1: 451,
    },
    {
      AGE: 74,
      14: 24810,
      13: 22329,
      12: 19848,
      11: 17367,
      10: 14886,
      9: 12405,
      8: 9924,
      7: 7443,
      6: 4962,
      5: 3473,
      4: 2481,
      3: 1488,
      2: 992,
      1: 496,
    },
    {
      AGE: 75,
      14: 27210,
      13: 24489,
      12: 21768,
      11: 19047,
      10: 16326,
      9: 13605,
      8: 10884,
      7: 8163,
      6: 5442,
      5: 3809,
      4: 2721,
      3: 1632,
      2: 1088,
      1: 544,
    },
  ],
  PRICE_C: [
    { AGE: 3, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 4, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 5, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 6, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 7, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 8, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 9, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 10, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 11, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 12, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 13, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 14, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 15, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 16, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 17, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 18, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 19, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 20, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 21, 1: 70, 2: 140, 3: 210, 4: 280 },
    { AGE: 22, 1: 70, 2: 140, 3: 210, 4: 280 },
  ],
};
export { PRICE_LIST_SEIMEI_COURSE };
